query totalCompromissos(
    $status: Int
    $where: CompromissoModelFilterInput) {
    data: compromissosOffsetPagination(
        status: $status
        where: $where) {
        totalCount
    }
}